import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMProject } from "../graphql/mutations";
import {
  UpdateLLMProjectInput,
  UpdateLLMProjectMutation,
} from "../API";

export async function updateLLMProjectAfterEdit(
  values: UpdateLLMProjectInput
): Promise<GraphQLResult<UpdateLLMProjectMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMProject, {
      input: {
        id: values.id,
        name: values.name,
        status: values.status,
        description: values.description || "Manages LLM features for " + values.name,
        newCustomerTokenCount: values.newCustomerTokenCount || 0,
        cacheResponsesForSeconds: values.cacheResponsesForSeconds || 0,
        promptBlacklist: values.promptBlacklist || "",
        loadSheddingTier: values.loadSheddingTier || 0,
        newCustomerLoadSheddingTier: values.newCustomerLoadSheddingTier || 2,
        maintenanceMode: values.maintenanceMode || false,
        maintenanceModeMessage: values.maintenanceModeMessage || "We are currently performing maintenance on this service. Please try again later.",
        loadBalancingMode: values.loadBalancingMode || "proportion",
        systemInstructions: values.systemInstructions || "",
        mcpServerWhitelist: values.mcpServerWhitelist || "",
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMProjectMutation>>;
}
